import React, { useRef, useState, useEffect } from "react";
import { Card, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLock,
  faEye,
  faEyeSlash
} from "@fortawesome/free-solid-svg-icons";
import voltupLogo from "../../assets/images/voltup-logo.png";
import "./../../assets/css/otp-component.css";
import { useResetPasswordMutation } from "../api/resetPasswordApiSlice";
import Loading from "./Loading";

const ReasetPasswordCard = (props) => {
  const errRef = useRef();
  const [errorMessage, setErrorMessage] = useState("");
  const [disableSubmit, setDisableSubmit] = useState(true);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState("");
  const [resetPassword, {isLoading}] = useResetPasswordMutation();

  useEffect(() => {
    setErrorMessage("");
    const isPasswordValid = password.length >= 8 && /[a-zA-Z]/.test(password) && /\d/.test(password) && /[!@#$%^&*(),.?":{}|<>]/.test(password);
    const passwordsMatch = password === confirmPassword;
  
    setDisableSubmit(!isPasswordValid || !passwordsMatch);
  }, [password, confirmPassword]);

  useEffect(() => {
    if (errorMessage != "") {
      setDisableSubmit(true);
    }
  }, [errorMessage]);

  if(isLoading){
    return <Loading />
  }

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handlePasswordInput = (e) => {
    setPassword(e.target.value);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleConfirmPasswordInput = (e) => {
    setConfirmPassword(e.target.value);
  };

  const onResetPasswordClick = async () => {

    try {
      let response = await resetPassword({mobile_number: props.mobileNumber, new_password: {password: password, password_confirmation: confirmPassword }}).unwrap();
      props.onSuccess();
    } catch (err) {
      if (!err?.status) {
        // isLoading: true until timeout occurs
        setErrorMessage("No Server Response");
      } else if (err.status === 400) {
        setErrorMessage("Missing Username or Password");
      } else if (err.status === 401) {
        setErrorMessage("Unauthorized");
      } else {
        setErrorMessage("Something went wrong");
      }
      errRef.current.focus();
    }
  }

  return (
    <React.Fragment>
        <Card className="login-card">
          <Card.Img variant="top" src={voltupLogo} />
          <Card.Body>
            <Row>
              <Col md={{ span: 10, offset: 1 }}>
                <div ref={errRef}>{errorMessage}</div>
                <Row className="mb-2 text-center">
                  <Col>
                    <h4>Enter New Password</h4>
                    <p className="text-success"><em>Password must be 8 or more characters with a mix of letters, number & symbols.</em></p>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col>
                    <div className="input-icon-wrapper">
                      <FontAwesomeIcon className="icon-left" icon={faLock} />
                      <input
                        type={showPassword ? "text" : "password"}
                        value={password}
                        onChange={handlePasswordInput}
                        placeholder="Password"
                      />
                      <FontAwesomeIcon
                        className="icon-right"
                        icon={showPassword ? faEyeSlash : faEye}
                        onClick={togglePasswordVisibility}
                      />
                    </div>
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col>
                    <div className="input-icon-wrapper">
                      <FontAwesomeIcon className="icon-left" icon={faLock} />
                      <input
                        type={showConfirmPassword ? "text" : "password"}
                        value={confirmPassword}
                        onChange={handleConfirmPasswordInput}
                        placeholder="Confirm Password"
                      />
                      <FontAwesomeIcon
                        className="icon-right"
                        icon={showConfirmPassword ? faEyeSlash : faEye}
                        onClick={toggleConfirmPasswordVisibility}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                   <button
                      onClick={onResetPasswordClick}
                      disabled={disableSubmit} className="btn">
                      Reset
                    </button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Card.Body>
        </Card>
    </React.Fragment>

  );
};

export default ReasetPasswordCard;
